import React, { useState } from "react";
import { Layout } from "../components/Layout";
import Axios from "axios";
import { socialMedial } from "../data/socialMedial";

const data = { site: require("../data/site.json") };
const { site } = data;

const mailEndpoint = "https://asess-econsult.herokuapp.com/api/v1/second-opinion/contact_us/";
const mailEndpointAppointment = "https://asess-econsult.herokuapp.com/api/v1/second-opinion/book_appointment/";

const contactInfo = [
  {
    icon: "fas fa-map-marker-alt",
    label: "Headquarters",
    value: "576 Independence Avenue CBD, FCT, Abuja, Nigeria",
    sub: "No 22A Obgunike Street, Lekki Phase 1, Lagos",
    color: "#37514B",
  },
  {
    icon: "fas fa-map-marker-alt",
    label: "Enugu Office",
    value: "East Side Hospital Independence Ave, Independence Layout, Enugu 400102, Enugu, Nigeria",
    sub: "+234 902 400 0024",
    href: "tel:+2349024000024",
    color: "#37514B",
  },
  {
    icon: "fas fa-phone-alt",
    label: "Call Us",
    value: "08065209446",
    sub: "08130790883 · 09024000024",
    href: "tel:08065209446",
    color: "#00b8b8",
  },
  {
    icon: "fas fa-envelope",
    label: "Email Us",
    value: site.email,
    sub: "We reply within 24 hours",
    href: `mailto:${site.email}`,
    color: "#4a6d65",
  },
];

export const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email_address: "", phone_number: "", message: "" });
  const [status, setStatus] = useState(null); // 'loading' | 'success' | 'error'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("loading");
    Axios.post(mailEndpoint, formData)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  };

  return (
    <Layout
      title={"Contact Us Today"}
      bgimage={require("../media/images/e-health/call-center.jpg").default}
      jumpto="contact"
    >
      {/* ── Contact Info Cards ── */}
      <section
        id="contact"
        style={{
          padding: "5rem 0",
          background: "linear-gradient(180deg,#f0f9f9 0%,#fff 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div style={{ position: "absolute", width: 500, height: 500, background: "rgba(0,184,184,0.07)", borderRadius: "50%", filter: "blur(80px)", top: -150, right: -150, pointerEvents: "none" }} />
        <div style={{ position: "absolute", width: 350, height: 350, background: "rgba(55,81,75,0.07)", borderRadius: "50%", filter: "blur(60px)", bottom: -80, left: -100, pointerEvents: "none" }} />

        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="row justify-content-center" style={{ marginBottom: "3.5rem" }}>
            <div className="col-12 col-lg-7 text-center">
              <div className="section-tag">Get In Touch</div>
              <div className="accent-line accent-line-center" style={{ margin: "1rem auto 1.5rem" }} />
              <h2 className="section-title-modern">
                We'd Love to <span>Hear From You</span>
              </h2>
              <p style={{ color: "#6b7280", lineHeight: 1.8 }}>
                Have questions about our services? Reach out to our team and we'll get back to you as soon as possible.
              </p>
            </div>
          </div>

          <div className="row g-4 justify-content-center" style={{ marginBottom: "5rem" }}>
            {contactInfo.map((item, i) => (
              <div key={i} className={`col-12 col-md-4 card-animate-in`} style={{ animationDelay: `${i * 0.1}s` }}>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: 20,
                    padding: "2rem",
                    boxShadow: "0 15px 50px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(0,184,184,0.1)",
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                    transition: "all 0.4s ease",
                    textAlign: "center",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-8px)"; e.currentTarget.style.boxShadow = "0 25px 70px rgba(0,0,0,0.14)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.08)"; }}
                >
                  <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg,${item.color},#00b8b8)` }} />
                  <div style={{ width: 60, height: 60, borderRadius: 16, background: `${item.color}15`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.3rem", color: item.color, margin: "0 auto 1.25rem" }}>
                    <i className={item.icon} />
                  </div>
                  <div style={{ fontSize: "0.75rem", color: "#9ca3af", fontWeight: 700, textTransform: "uppercase", letterSpacing: 2, marginBottom: "0.5rem" }}>{item.label}</div>
                  {item.href ? (
                    <a href={item.href} style={{ fontWeight: 700, color: "#1a2332", fontSize: "1rem", display: "block", marginBottom: "0.4rem", textDecoration: "none", transition: "color 0.3s" }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = item.color; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = "#1a2332"; }}>
                      {item.value}
                    </a>
                  ) : (
                    <div style={{ fontWeight: 700, color: "#1a2332", fontSize: "0.95rem", marginBottom: "0.4rem" }}>{item.value}</div>
                  )}
                  <div style={{ color: "#9ca3af", fontSize: "0.82rem" }}>{item.sub}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Contact Form + Map ── */}
          <div className="row g-5 align-items-stretch">
            {/* Form */}
            <div className="col-12 col-lg-6">
              <div
                style={{
                  background: "linear-gradient(135deg,#253832 0%,#1a4a42 100%)",
                  borderRadius: 24,
                  padding: "3rem",
                  boxShadow: "0 30px 80px rgba(0,0,0,0.18)",
                  position: "relative",
                  overflow: "hidden",
                  height: "100%",
                }}
              >
                <div style={{ position: "absolute", top: -60, right: -60, width: 200, height: 200, background: "rgba(0,184,184,0.12)", borderRadius: "50%", pointerEvents: "none" }} />
                <div style={{ position: "absolute", bottom: -80, left: -40, width: 250, height: 250, background: "rgba(0,184,184,0.06)", borderRadius: "50%", pointerEvents: "none" }} />

                <div style={{ position: "relative", zIndex: 1 }}>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(0,184,184,0.2)", border: "1px solid rgba(0,184,184,0.35)", color: "#4dd9d9", padding: "0.35rem 1rem", borderRadius: 50, fontSize: "0.78rem", fontWeight: 600, letterSpacing: 1, textTransform: "uppercase", marginBottom: "1.25rem" }}>
                    <span style={{ width: 7, height: 7, background: "#00b8b8", borderRadius: "50%", display: "inline-block" }} />
                    Send a Message
                  </div>
                  <h3 style={{ color: "#fff", fontWeight: 700, marginBottom: "0.4rem", fontSize: "1.5rem" }}>How Can We Help?</h3>
                  <p style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.88rem", marginBottom: "2rem" }}>Fill in the form and we'll respond within 24 hours.</p>

                  {status === "success" ? (
                    <div style={{ background: "rgba(0,184,184,0.15)", border: "1px solid rgba(0,184,184,0.4)", borderRadius: 16, padding: "2rem", textAlign: "center" }}>
                      <i className="fas fa-check-circle" style={{ fontSize: "2.5rem", color: "#00b8b8", marginBottom: "1rem", display: "block" }} />
                      <h5 style={{ color: "#fff", fontWeight: 700, marginBottom: "0.5rem" }}>Message Sent!</h5>
                      <p style={{ color: "rgba(255,255,255,0.7)", margin: 0, fontSize: "0.9rem" }}>We'll get back to you as soon as possible.</p>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} className="dark-form">
                      {[
                        { name: "name", type: "text", placeholder: "Your full name", icon: "fas fa-user" },
                        { name: "email_address", type: "email", placeholder: "Your email address", icon: "fas fa-envelope" },
                        { name: "phone_number", type: "tel", placeholder: "Your phone number", icon: "fas fa-phone" },
                      ].map((field) => (
                        <div key={field.name} style={{ position: "relative", marginBottom: 0 }}>
                          <div style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "rgba(255,255,255,0.45)", fontSize: "0.85rem", pointerEvents: "none", zIndex: 2 }}>
                            <i className={field.icon} />
                          </div>
                          <input type={field.type} name={field.name} placeholder={field.placeholder} onChange={handleChange} value={formData[field.name]} required />
                        </div>
                      ))}
                      <div style={{ position: "relative" }}>
                        <textarea name="message" rows={4} placeholder="How can we help you?" onChange={handleChange} value={formData.message} required className="no-icon" />
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1.25rem" }}>
                        <input type="checkbox" id="terms" required style={{ width: "auto", marginBottom: 0 }} />
                        <label htmlFor="terms" style={{ color: "rgba(255,255,255,0.65)", fontSize: "0.82rem", cursor: "pointer", margin: 0 }}>
                          I accept the{" "}
                          <a href="/p/terms-of-services" style={{ color: "#00b8b8", textDecoration: "underline" }}>terms &amp; conditions</a>{" "}
                          and{" "}
                          <a href="/p/privacy-policy" style={{ color: "#00b8b8", textDecoration: "underline" }}>privacy policy</a>.
                        </label>
                      </div>
                      <button
                        type="submit"
                        disabled={status === "loading"}
                        style={{
                          width: "100%",
                          padding: "1rem",
                          background: status === "loading" ? "rgba(255,255,255,0.2)" : "linear-gradient(135deg,#37514B 0%,#00b8b8 100%)",
                          border: "none",
                          borderRadius: 12,
                          color: "#fff",
                          fontSize: "1rem",
                          fontWeight: 700,
                          cursor: status === "loading" ? "not-allowed" : "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 10,
                          transition: "all 0.3s ease",
                          boxShadow: "0 8px 25px rgba(0,184,184,0.35)",
                        }}
                        onMouseEnter={(e) => { if (status !== "loading") { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,184,184,0.5)"; } }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,184,184,0.35)"; }}
                      >
                        {status === "loading" ? (
                          <><i className="fas fa-spinner fa-spin" /> Sending...</>
                        ) : (
                          <><i className="fas fa-paper-plane" /> Send Message</>
                        )}
                      </button>
                      {status === "error" && (
                        <p style={{ color: "#ff6b6b", fontSize: "0.85rem", marginTop: "0.75rem", textAlign: "center" }}>
                          Something went wrong. Please try again or call us directly.
                        </p>
                      )}
                    </form>
                  )}
                </div>
              </div>
            </div>

            {/* Right side: social + quick links */}
            <div className="col-12 col-lg-6">
              <div style={{ height: "100%", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                {/* Social */}
                <div style={{ background: "#fff", borderRadius: 20, padding: "2rem", boxShadow: "0 15px 50px rgba(0,0,0,0.08)", border: "1px solid rgba(0,184,184,0.1)" }}>
                  <h5 style={{ fontWeight: 700, color: "#1a2332", marginBottom: "1.25rem", fontSize: "1rem" }}>Connect With Us</h5>
                  <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
                    {socialMedial.map((item, i) => (
                      <a
                        key={i}
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 8,
                          padding: "0.6rem 1.25rem",
                          borderRadius: 50,
                          background: "rgba(0,184,184,0.08)",
                          border: "1px solid rgba(0,184,184,0.15)",
                          color: "#37514B",
                          fontSize: "0.85rem",
                          fontWeight: 600,
                          textDecoration: "none",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = "linear-gradient(135deg,#37514B,#00b8b8)"; e.currentTarget.style.color = "#fff"; e.currentTarget.style.borderColor = "transparent"; e.currentTarget.style.transform = "translateY(-3px)"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(0,184,184,0.08)"; e.currentTarget.style.color = "#37514B"; e.currentTarget.style.borderColor = "rgba(0,184,184,0.15)"; e.currentTarget.style.transform = "translateY(0)"; }}
                      >
                        <i className={item.icon} /> {item.name}
                      </a>
                    ))}
                  </div>
                </div>

                {/* Quick emergency */}
                <div style={{ background: "linear-gradient(135deg,#37514B,#00b8b8)", borderRadius: 20, padding: "2rem", position: "relative", overflow: "hidden" }}>
                  <div style={{ position: "absolute", top: -40, right: -40, width: 150, height: 150, background: "rgba(255,255,255,0.08)", borderRadius: "50%" }} />
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: "1rem" }}>
                      <div style={{ width: 48, height: 48, borderRadius: 14, background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: "1.2rem" }}>
                        <i className="fas fa-ambulance" />
                      </div>
                      <div>
                        <div style={{ fontWeight: 700, color: "#fff", fontSize: "1rem" }}>Need Urgent Help?</div>
                        <div style={{ color: "rgba(255,255,255,0.75)", fontSize: "0.82rem" }}>Our doctors are available 24/7</div>
                      </div>
                    </div>
                    <a href="tel:08130790883" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: "#fff", padding: "0.75rem 1.5rem", borderRadius: 50, fontWeight: 700, textDecoration: "none", fontSize: "0.95rem", transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.25)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.15)"; }}>
                      <i className="fas fa-phone-alt" /> 08130790883
                    </a>
                  </div>
                </div>

                {/* Map embed */}
                <div style={{ borderRadius: 20, overflow: "hidden", boxShadow: "0 15px 50px rgba(0,0,0,0.1)", flex: 1, minHeight: 220 }}>
                  <iframe
                    title="24Telemed Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.251234481783!2d7.471396700000002!3d9.0408322!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0b71eed03053%3A0x603a2a6f28a856de!2s576%20Independence%20Ave%2C%20Central%20Business%20Dis%20900103%2C%20Abuja!5e0!3m2!1sen!2sng!4v1697539509807!5m2!1sen!2sng"
                    width="100%"
                    height="100%"
                    style={{ border: 0, display: "block", minHeight: 220, filter: "grayscale(20%)" }}
                    allowFullScreen=""
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const ContactPop = ({ room, option, price }) => {
  return (
    <form
      id="contact-form"
      action={mailEndpointAppointment}
      method="post"
      className="white-popup-block col-xl-4 col-lg-7 col-sm-9 p-0 mx-auto mfp-hide"
    >
      <div style={{ padding: "2rem", background: "#fff", borderRadius: 16 }}>
        <h6 style={{ fontWeight: 700, color: "#1a2332", marginBottom: "0.5rem" }}>Hassle Free Appointment</h6>
        <p style={{ color: "#6b7280", fontSize: "0.88rem", marginBottom: "1.5rem" }}>
          No worries. No travel. Get your medical care from the comfort of your home.
        </p>
        <div className="light-form">
          {[
            { name: "name", type: "text", placeholder: "Your name", icon: "fas fa-user" },
            { name: "email", type: "email", placeholder: "Your email address", icon: "fas fa-envelope" },
            { name: "phone", type: "tel", placeholder: "Your mobile", icon: "fas fa-phone" },
          ].map((f) => (
            <div key={f.name} style={{ position: "relative" }}>
              <div style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "#9ca3af", fontSize: "0.85rem", zIndex: 2, pointerEvents: "none" }}>
                <i className={f.icon} />
              </div>
              <input type={f.type} name={f.name} placeholder={f.placeholder} />
            </div>
          ))}
          <textarea name="message" rows={4} placeholder="Additional message" className="no-icon" />
          <button type="submit" style={{ width: "100%", padding: "0.9rem", background: "linear-gradient(135deg,#37514B,#00b8b8)", border: "none", borderRadius: 12, color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: "0.95rem" }}>
            Book Appointment
          </button>
        </div>
        <div className="form-results d-none" />
      </div>
    </form>
  );
};
